<template>
<div class="description">
  <div class="title_level1 title_level1_2">
    <div class="icon"></div>
    保监许可
  </div>
  <p>
    骆驼规划是润安国际保险经纪有限公司的核心品牌，拥有中国保险监督管理委员会颁发的经营保险经纪业务许可证，是一家专业中立的第三方保障规划平台。
  </p>
  <p>
    查询地址：http://iir.circ.gov.cn/
  </p>
  <div class="img_border">
    <img src="@/assets/images/version/about4.png" alt="保监许可"/>
  </div>
  <div style="margin-top: 70px;" class="title_level1 title_level1_2">
    <div class="icon"></div>
    营业执照
  </div>
  <div class="img_border">
    <img src="@/assets/images/version/about5.jpg" alt="营业执照"/>
  </div>
</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
</style>
